<template>
  <v-list-item
    :class="['session-list-item', { 'session-list-item--active': isActive }]"
    @click="$emit('select', session)"
  >
    <v-list-item-content>
      <v-list-item-title class="session-list-item__title">
        {{ session.title || 'Untitled Conversation' }}
      </v-list-item-title>

      <v-list-item-subtitle class="session-list-item__preview">
        {{ session.summary || '' }}
      </v-list-item-subtitle>

      <div class="session-list-item__meta">
        <span class="session-list-item__meta-item">
          <v-icon x-small>mdi-clock-outline</v-icon>
          <span>{{ formattedTimestamp }}</span>
        </span>
        <span class="session-list-item__meta-item">
          <v-icon x-small>mdi-message-outline</v-icon>
          <span>{{ session.message_count }} messages</span>
        </span>
      </div>
    </v-list-item-content>

    <v-list-item-action>
      <v-btn
        icon
        small
        class="session-list-item__delete"
        aria-label="Delete session"
        @click.stop="$emit('delete', session)"
      >
        <v-icon small color="error">mdi-trash-can-outline</v-icon>
      </v-btn>
    </v-list-item-action>
  </v-list-item>
</template>

<script lang="ts">
import Vue from 'vue';

import { IChatSession } from '@/bundles/AiAgent/types';
import { formatRelativeTime } from '@/bundles/AiAgent/utils/formatRelativeTime';

export default Vue.extend({
  name: 'AiSessionListItem',

  props: {
    session: {
      type: Object as () => IChatSession,
      required: true
    },
    isActive: Boolean
  },

  computed: {
    formattedTimestamp (): string {
      const timestamp = this.session.last_message_at || this.session.created_at;
      return formatRelativeTime(timestamp ? new Date(timestamp) : null);
    }
  }
});
</script>

<style lang="scss" scoped>
.session-list-item {
  border-left: 4px solid transparent;
  transition: background-color 0.2s ease;
  cursor: pointer;

  &:hover {
    background-color: #f9fafb;

    .session-list-item__delete {
      opacity: 1;
    }
  }

  &--active {
    background-color: #eff6ff;
    border-left-color: var(--v-primary-base);

    .session-list-item__title {
      color: var(--v-primary-base);
    }
  }

  &__title {
    font-size: 14px;
    font-weight: 500;
    color: #111827;
  }

  &__preview {
    font-size: 12px;
    color: #6b7280;
    margin-top: 4px;
  }

  &__meta {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 8px;
  }

  &__meta-item {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    color: #9ca3af;

    .v-icon {
      color: #9ca3af;
    }
  }

  &__delete {
    opacity: 0;
    transition: opacity 0.2s ease;

    &:hover {
      background-color: #fef2f2;
    }
  }
}
</style>
